// utils
import axios from '../../utils/axios';

const createUser = async (data) => {
  try {
    const response = await axios({
      method: 'post',
      url: `/auth/register`,
      data,
    });
    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export { createUser };
